import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const propertyTypeMap: Record<PropertyType, MapItem> = {
  single_family: { label: 'Single Family' },
  condo: { label: 'Condo' },
  co_op: { label: 'Co-op' },
  multi_family: { label: 'Multi Family' },
  townhouse: { label: 'Townhouse' },
  other: { label: 'Other' },
}

export const propertyTypeSchema = z.enum(Object.keys(propertyTypeMap) as [PropertyType, ...PropertyType[]])

export type PropertyType = 'single_family' | 'condo' | 'co_op' | 'multi_family' | 'townhouse' | 'other'
